var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.basketIs.initial && !_vm.userIs.initial)?_c('address-line',{attrs:{"user":_vm.user,"address":_vm.userAddress,"inline":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }